import React, { useRef, useContext, useState, useEffect } from "react";
import Rightside from "../../components/rightside/Rightside";
import logo from "../../images/white-logo.png";
import Navbar from "../../components/navbar/Navbar";
import Rating from "../../components/rating/Rating";
import { BiSearch } from "react-icons/bi";
import Banner from "../../components/banner/Banner";
import img from "../../images/banner4.png";
import akash from "../../images/institute.png";
import { AiOutlinePlus } from "react-icons/ai";
import { TbGitCompare } from "react-icons/tb";
import { Link } from "react-router-dom";
import Faculty from "../../components/faculty/Faculty";
import Job from "../../components/job/Job";
import image from "../../images/post3.png";
import Table from "react-bootstrap/Table";
import Review from "../../components/review/Review";
import Rated from "../../components/filterRating/Rated";
import { AiFillStar } from "react-icons/ai";
import parse from "html-react-parser";
import bann from "../../images/banner5.png";
import { tabledata, reviewdata } from "../../data";
import Footer from "../../components/footer/Footer";
import axios from "axios";
import { useParams } from "react-router-dom";
import RatingContext from "../../components/RatingContext";
import Gallery from "../../components/faculty/Gallery";
import "./institute.css";
import FooterMob from "../../components/footer/FooterMob";
import { baseUrl } from "../../context/BaseUrl";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MobNav from "../../components/Mobnav/MobNav";
import Facultysm from "../../components/faculty/Facultysm";
import { Accordion } from "react-bootstrap";

const Institute = () => {
  const { id } = useParams();
  // const val = JSON.parse(localStorage.getItem("user"));
  // let vid = false;
  // // let token = false;
  // if (val) {
  //   let vid = val._id;
  //   let token = val.token;
  // }
  const user = localStorage.getItem("user");
  const comp = () => {
    if (user) {
    } else {
      toast.error("You are not logged in.");
      return;
    }
  };
  const { ratingAverage, setRatingAverage } = useContext(RatingContext);

  //for scroll
  // const ref = useRef(null);
  // const handleClick = () => {
  //   ref.current?.scrollIntoView({ behaviour: 'smooth' });
  // };
  const [Loading, setLoading] = useState(false);
  const [vacancyData, setVacancyData] = useState(false);
  const [reviewsData, setReviewsData] = useState(false);
  // const [, set] = useState(false);
  // const [, set] = useState(false);
  const colors = ["#65D370", "#FC9C9C", "#FFBD3D"];

  const aboutToRef = useRef();

  const selectionToRef = useRef();
  const feeToRef = useRef();
  const scrollToRef = useRef();

  const writeReviewToRef = useRef();

  const facultToRef = useRef();

  const galleryToRef = useRef();

  const jobToRef = useRef();

  const [Data, setData] = useState(false);

  const fetchData = async () => {
    const int_id = id;
    const response = await fetch(
      `${baseUrl}/user/institute/getinstitute/${int_id}`,
      {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    const resp = await response.json();

    console.log("resp__", resp);

    setData(resp);
    setReviewsData(resp.reviews[0])
  };

  const Follow = async (institute_id) => {
    try {
      const checkUser = localStorage.getItem("user");
      if (!checkUser) {
        // alert("you are not logged in.");
        toast.error("you are not logged in.");
        return;
      }

      const user = JSON.parse(checkUser);

      const user_id = user.user._id;
      const token = user.token;

      setLoading(true);
      const data = {
        institute_id,
        user_id: user.user._id,
      };
      const response = await fetch(
        `${baseUrl}/user/user_rights/postfollow/${user_id}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      const result = await response.json();

      if (result.code == 500) {
        toast.error(result.msg);
        return;
      }
      toast.success(result.msg);

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  function Sliding_banner({ src }) {
    return (
      <div className="home-banner pt-mobile-0">
        <img src={src} alt="" />
      </div>
    );
  }

  const Values = (data) => {
    console.log(data);
  };

  return (
    Data && (
      <React.Fragment>
        <ToastContainer />
        <div className="home-background">
          <Navbar logoimg={logo} />
        </div>

        <MobNav />

        <div className="instutute-page ">
          <h4 className="pb-mobile-2">{Data.institute_profile[0].name}</h4>
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-8 col-md-7 col-sm-12 col-xs-12 px-mobile-0">
                <div className="leftside">
                  {/* search end*/}
                  {/* <Banner bannerimg={img} /> */}
                  <Sliding_banner src={Data.institute_profile[0].sliding_banner} />
                  <h6>
                    <span className="pointer">NEET </span>{" "}
                    <span className="pointer">JEE Main</span>{" "}
                    <span
                      onClick={() => writeReviewToRef.current.scrollIntoView()}
                      className="pointer review"
                    >
                      Write a review
                    </span>
                  </h6>

                  <div className="d-flex overexp">
                    <img src={Data.institute_profile[0].image} alt="akash" />
                    <div className="follow">
                      <h4>{Data.institute_profile[0].name}</h4>
                      <span
                        onClick={() => Follow(Data.institute_profile[0].institute_id)}
                        className="folbtn"
                      >
                        <AiOutlinePlus /> {Loading ? "Loading" : "Follow"}
                      </span>{" "}
                      <span>{/*14 k Followers*/}</span>
                    </div>

                    <div className="compare">
                      <p>
                        <span>
                          {(Data.institute_rating[0]
                            ? Data.institute_rating[0].rating / 2
                            : 0
                          ).toFixed(1)}
                        </span>
                        Rating (
                        {Data.institute_rating[0]
                          ? Data.institute_rating[0].totalRatingCount
                          : 0}
                        )
                      </p>
                      <button onClick={comp}>
                        <Link to={user ? `/compares/${Data.institute_profile[0].institute_id}` : ""}>
                          <TbGitCompare /> Compare
                        </Link>
                      </button>
                    </div>
                  </div>

                  <div className="overexp overexp-sm py-1">
                    <img src={Data.institute_profile[0].image} alt="akash" />
                    <div className="follow">
                      <h4>{Data.institute_profile[0].name}</h4>
                      <p><span>{(Data.institute_rating[0]
                            ? Data.institute_rating[0].rating / 2
                            : 0
                          ).toFixed(1)}</span> Rating (
                            {Data.institute_rating[0]
                              ? Data.institute_rating[0].totalRatingCount
                              : 0}
                            )</p>
                    </div>

                    <div className="compare">
                      <p
                        onClick={() => Follow(Data.institute_profile[0].institute_id)}
                        className="folbtn"
                      >
                        <AiOutlinePlus /> {Loading ? "Loading" : "Follow"}
                      </p>
                      <p className="followers">{/*14 k Followers*/}</p>
                    </div>
                  </div>
                  <div className="compare-btns-sm d-flex d-md-none pb-2 ">
                    <button className="mt-2" >
                      <Link to={`/compares/${Data.institute_profile[0].institute_id}`}>
                        <TbGitCompare /> Compare
                      </Link>
                    </button>
                    <button className="mt-2">
                      <Link
                        to={""}
                        onClick={() =>
                          writeReviewToRef.current.scrollIntoView()
                        }
                      >
                        {" "}
                        Write a review
                      </Link>
                    </button>
                  </div>

                  {/* follow end*/}
                  <div className="tab-view">
                    <ul className="nav sticky-top bg-white scale p-mobile-0">
                      <li className="px-mobile-0 py-mobile-0">
                        <Link
                          to=""
                          className="active"
                          onClick={() => aboutToRef.current.scrollIntoView()}
                        >
                          About
                        </Link>
                      </li>
                      <li>
                        <Link
                          to=""
                          onClick={() => scrollToRef.current.scrollIntoView()}
                        >
                          Courses
                        </Link>
                      </li>
                      <li>
                        <Link
                          to=""
                          onClick={() => facultToRef.current.scrollIntoView()}
                        >
                          Faculty
                        </Link>
                      </li>
                      <li>
                        <Link
                          to=""
                          onClick={() => galleryToRef.current.scrollIntoView()}
                        >
                          Gallery
                        </Link>
                      </li>
                      <li>
                        <Link
                          to=""
                          onClick={() => jobToRef.current.scrollIntoView()}
                        >
                          Job Vacancies
                        </Link>
                      </li>
                      <li>
                        <Link
                          to=""
                          onClick={() => feeToRef.current.scrollIntoView()}
                        >
                          Fee
                        </Link>
                      </li>
                    </ul>

                    {/* tab-view end */}
                    <div className="tab-content">
                      <div className="about mt-4" ref={aboutToRef}>
                      <h4 className="pt-2">About</h4>
                        <p>{parse(Data.institute_profile[0].about)}</p>
                        <div className="video">
                          <iframe
                            width="100%"
                            height="350"
                            src={Data.institute_profile[0].video}
                            title="YouTube video player"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                          ></iframe>
                        </div>
                      </div>
                      <div className="about mt-4">
                        <h4>Contact us</h4>
                        <p>{Data.institute_profile[0].contact ? parse(Data.institute_profile[0].contact) : ""}</p>
                      </div>
                      <div className="course " ref={scrollToRef}>
                        <h4>Courses</h4>
                        <div className="scroll">
                          <Table>
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Duration</th>
                                <th>Fee</th>
                                <th>Rating</th>
                                <th>Medium</th>
                                <th>Details</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Data.course.map((val, key) => {
                                return (
                                  <tr key={key}>
                                    <td>{val.course}</td>
                                    <td>{val.duration}</td>
                                    <td>
                                    <p className="mb-0">{val.offline ?  "Offline"+" "+"₹"+val.offline : ""}</p>
                                    <p className="mb-0">{val.online ? "Online"+" "+"₹"+val.online : ""}</p>
                                    </td>
                                    <td>
                                      <span>{val.rating ?? 0}</span>
                                    </td>
                                    <td>{val.medium}</td>
                                    <td>
                                      <Link to={`/course/${val._id}`}>
                                        View
                                      </Link>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </Table>
                        </div>
                      </div>

                      <div className="faculty" ref={facultToRef}>
                        <h4>Faculty</h4>
                        
                        <Faculty data={Data.faculty} />
                        <Facultysm data={Data.faculty} />
                        
                      </div>
                      <div className="gallery" ref={galleryToRef}>
                        <h4>Gallery</h4>
                        <div className="row gallery-pc">
                          {Data.gallary.map((item) => (
                            <div className="col-md-4">
                              <img
                                src={item.files[0]}
                                alt="image1"
                                className="gallery"
                              />
                            </div>
                          ))}
                        </div>
                        <div className="gallery-slider">
                          <Gallery data={Data} />
                        </div>
                      </div>
                      <div className="job-vacancy" ref={jobToRef}>
                      <div className="d-flex">
                        <h4>Job Vacancy</h4>
                        <h4 className="ms-auto"><span><Link to={"/vacancy"} className="btn ">See all Vacancy</Link></span></h4>
                       </div>
                        <Job id={id} />
                      </div>
                      <div className="about pt-4" ref={feeToRef}>
                      <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                          <Accordion.Header><h6 className="py-0 fw-semibold">Payment in installment</h6></Accordion.Header>
                            <Accordion.Body>
                            <p>{Data.institute_profile[0].emi ? parse(Data.institute_profile[0].emi) : ""}</p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                            <Accordion.Header><h6 className="py-0 fw-semibold">Fee refund</h6></Accordion.Header>
                            <Accordion.Body>
                              <p>{Data.institute_profile[0].fee_refund ? parse(Data.institute_profile[0].fee_refund) : ""}</p>
                            </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                            <Accordion.Header><h6 className="py-0 fw-semibold">personal mentorship</h6></Accordion.Header>
                            <Accordion.Body>
                              <p>{Data.institute_profile[0].mentorship ? parse(Data.institute_profile[0].mentorship) : ""}</p>
                            </Accordion.Body>
                          </Accordion.Item>
                        </Accordion>
                        
                      </div>
                      <h4>Reviews </h4>
                      {Data.reviews[0] != undefined ? Data.reviews.map((val, key) => {
                        return (
                          <div className="rev row pb-5" key={key}>
                            <div className="col-md-1 col-3 d-flex justify-content-center align-items-start">
                              <h6>{val.name[0]}</h6>
                            </div>
                            <div className="text col-9 col-md-10">
                              <h5 className="d-flex justify-content-between text-capitalize">
                                {val.name}{" "}
                                <span>
                                  <Rated rated={val.rating} />
                                </span>
                              </h5>
                              <p className="desc">{parse(val.desc)}</p>
                              {/* <p className="quali p-0 m-0">
                                  B.Tech. in Mechanical Engineering
                          </p>*/}
                            </div>
                            {/* <div className="col-md-1"></div> */}
                          </div>
                        );
                      }) : "No reviews yet"}

                      
                      
                      {/* review description end*/}
                      <div className="write-review" ref={writeReviewToRef}>
                        <Review
                          reload={fetchData}
                          institute_id={id}
                          courseid={"null"}
                          userid={id}
                        />
                      </div>
                    </div>
                  </div>
                  {/* tab-content end*/}
                </div>
                {/* leftside end*/}
              </div>
              <div className="col-lg-4 col-md-5 col-sm-12 col-xs-12 px-0">
                <div className="rigthside">
                  <Rating
                    func={Values}
                    reload={fetchData}
                    institute_id={Data.institute_profile[0].institute_id}
                  />
                  <Rightside />
                  {/* <Banner bannerimg={bann} /> */}
                </div>
              </div>
              {/* rigthside end*/}
            </div>
          </div>
        </div>

        <Footer />
        <FooterMob />
      </React.Fragment>
    )
  );
};

export default Institute;
